<div [class.hidden]="!show">
    <div class="loader-overlay">
        <div *ngIf="show" class="loader"></div>
        <div *ngIf="message" class="loader-message" role="status" aria-live="polite">{{ message }}</div>
    </div>
</div>
